import { Card } from 'antd'
import cls from 'classnames'
import React from 'react'

import s from '../user-info.module.less'

export const UserInfoSectionLayout: React.FC<{
  title: string | React.ReactNode
  actions?: React.ReactNode
  icon?: React.ReactNode
  showActions?: boolean
}> = ({ title, icon, actions, showActions = false, children }) => {
  const [onHover, setOnHover] = React.useState(false)
  return (
    <div className={s.part} onMouseEnter={() => setOnHover(true)} onMouseLeave={() => setOnHover(false)}>
      <Card
        bodyStyle={{ paddingTop: 16, paddingBottom: 16 }}
        title={
          <div className={s.partTitle}>
            {icon}
            {title}
          </div>
        }
        extra={[
          <div key='actions' className={cls(s.actions, { [s.onHover]: showActions || onHover })}>
            {actions}
          </div>,
        ]}
      >
        {children}
      </Card>
    </div>
  )
}
